import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Loader } from '../../../../shared/components/Loader';
import { UploadFile } from '../../../../shared/components/UploadFile';
import Box from '@mui/material/Box';
import useXmlImport from '../../../../hooks/useXmlImport';
import { TabContext, TabList } from '@mui/lab';
import { Tab } from '@mui/material';
import * as Icon from '@mui/icons-material';
import { TabDados } from './components/TabDados';
import { TabEmitente } from './components/TabEmitente';
import { TabDestinario } from './components/TabDestinario';
import { TabTotais } from './components/TabTotais';
import { TabTransporte } from './components/TabTransporte';
import { TabCobranca } from './components/TabCobranca';
import { TabInformacoes } from './components/TabInformacoes';
import { TabItems } from './components/TabItems';
import { Button } from '../../../Styles/ScreenStyle';

const TABS = [
  {
    id: '1',
    label: 'Dados',
    icon: <Icon.InsertDriveFile />,
  },
  {
    id: '2',
    label: 'Emitente',
    icon: <Icon.Person />,
  },
  {
    id: '3',
    label: 'Destinatário',
    icon: <Icon.PersonOutline />,
  },
  {
    id: '4',
    label: 'Itens',
    icon: <Icon.ListAlt />,
  },
  {
    id: '5',
    label: 'Totais',
    icon: <Icon.AttachMoney />,
  },
  {
    id: '6',
    label: 'Transporte',
    icon: <Icon.LocalShipping />,
  },
  {
    id: '7',
    label: 'Cobrança',
    icon: <Icon.CreditCard />,
  },
  {
    id: '8',
    label: 'Informações',
    icon: <Icon.Info />,
  },
];

export default function ImportacaoXMLCadastrar() {
  const {
    handleFileChange,
    activeTab,
    handleTabChange,
    values,
    loading,
    forncedor,
    emitenteEmOutroPapel,
    marcarEmitenteComoFornecedor,
    updateEmitente,
    createEmitente,
    createTransportador,
    updateTransportador,
    transportador,
    modalSearchProduct,
    handleCloseModalSearchProduct,
    handleModalSearchProduct,
    modalSearchActiveProd,
    handleSearchProduct,
    productOptions,
    handleAutoCompleteSelected,
    confirmProductSelected,
    activeProductSelected,
    handleCreateProduct,
    handleSaveXML,
    saveXmlIsEnabled,
    showGroupProduct,
    paymentOptions,
    renderSelectGroup,
    handleGroupSelect,
    productGroup,
  } = useXmlImport();

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'CADASTRO DE IMPORTAÇÃO DE XML/TXT'} />
      <Box className='py-3'>
        <Box className='grid grid-cols-8 gap-7 pt-4'>
          <Box className='col-span-4 pt-1'>
            <UploadFile handleFileChange={handleFileChange} />
          </Box>
          <Box className='col-span-4'>
            <Button
              disabled={!saveXmlIsEnabled}
              className={'!px-6'}
              onClick={() => handleSaveXML()}
              variant='contained'
              color='primary'
              startIcon={<Icon.Save />}
            >
              Salvar XML
            </Button>
          </Box>
        </Box>
        <Box className={'pt-4'}>
          <TabContext value={activeTab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleTabChange}
                aria-label='lab API tabs example'
              >
                {TABS.map((item) => (
                  <Tab
                    key={item.id}
                    icon={item.icon}
                    label={item.label}
                    value={item.id}
                  />
                ))}
              </TabList>
            </Box>
            <TabDados values={values} />
            <TabEmitente
              values={values}
              forncedor={forncedor}
              emitenteEmOutroPapel={emitenteEmOutroPapel}
              marcarEmitenteComoFornecedor={marcarEmitenteComoFornecedor}
              updateEmitente={updateEmitente}
              createEmitente={createEmitente}
            />
            <TabDestinario values={values} />
            <TabItems
              values={values}
              handleCloseModalSearchProduct={handleCloseModalSearchProduct}
              modalSearchProduct={modalSearchProduct}
              handleModalSearchProduct={handleModalSearchProduct}
              modalSearchTitle={modalSearchActiveProd?.xProd ?? ''}
              handleSearchProduct={handleSearchProduct}
              productOptions={productOptions}
              handleAutoCompleteSelected={handleAutoCompleteSelected}
              confirmProductSelected={confirmProductSelected}
              activeProductSelected={activeProductSelected}
              handleCreateProduct={handleCreateProduct}
              showGroupProduct={showGroupProduct}
              paymentOptions={paymentOptions}
              renderSelectGroup={renderSelectGroup}
              handleGroupSelect={handleGroupSelect}
              productGroup={productGroup}
            />
            <TabTotais values={values} />
            <TabTransporte
              values={values}
              transportador={transportador}
              updateTransportador={updateTransportador}
              createTransportador={createTransportador}
            />
            <TabCobranca values={values} />
            <TabInformacoes values={values} />
          </TabContext>
        </Box>
      </Box>
    </Loader>
  );
}
